import { useEffect, useState } from "react";
import { FaChevronDown } from "react-icons/fa";
import { useNavigate, useParams } from "react-router-dom";
import { LIVE_URL } from "../../../config/config";
import useAuthToken from "../../../hooks/useAuthToken";
import Spinner from "../spinner/Spinner";
import styles from "./css/AddPreference.module.scss";

const AddPreference = () => {
  const { token } = useAuthToken();
  const { id } = useParams();

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [popupMessage, setPopupMessage] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Function to reset form fields
  const resetForm = () => {
    setTitle("");
    setDescription("");
    setSelectedStatus("");
    setPopupMessage("");
    setErrors({});
  };

  useEffect(() => {
    if (id) {
      const fetchPreferenceData = async () => {
        try {
          setLoading(true);
          const response = await fetch(`${LIVE_URL}/admin/brings/get/${id}`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          const data = await response.json();
          if (response.ok) {
            const preferenceData = data.data;
            setTitle(preferenceData.title);
            setDescription(preferenceData.description);
            setSelectedStatus(preferenceData.status ? "true" : "false");
          }
        } catch (error) {
          console.error("Error fetching preference data:", error);
        } finally {
          setLoading(false);
        }
      };
      fetchPreferenceData();
    } else {
      resetForm();
      // setLoading(false);
    }
  }, [id, token]);

  useEffect(() => {
    let timer;
    if (popupMessage) {
      const popupElement = document.getElementById("popup-message");
      if (popupElement) {
        popupElement.style.opacity = "1";
      }
      timer = setTimeout(() => {
        if (popupElement) {
          popupElement.style.opacity = "0";
        }
        setTimeout(() => {
          setPopupMessage("");
        }, 500);
      }, 2000);
    }
    return () => clearTimeout(timer);
  }, [popupMessage]);

  const handleSelectChange = (event) => {
    setSelectedStatus(event.target.value);
    setErrors((prevErrors) => ({ ...prevErrors, selectedStatus: "" }));
  };

  const handleTitleChange = (event) => {
    setTitle(event.target.value);
    setErrors((prevErrors) => ({ ...prevErrors, title: "" }));
  };

  const handleDescriptionChange = (event) => {
    setDescription(event.target.value);
    setErrors((prevErrors) => ({ ...prevErrors, description: "" }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    const newErrors = {};
    if (!title) newErrors.title = "❗ Don't Forget the Title!";
    if (!description)
      newErrors.description = "❗ Don't Forget the Description!";
    if (!selectedStatus)
      newErrors.selectedStatus = "❗Status field cannot be blank.";
    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      setPopupMessage("Please fill in all required fields");
      setLoading(false);
      return;
    }

    // const formData = new FormData();
    // formData.append("title", title);
    // formData.append("id", id);
    // formData.append("description", description);
    // formData.append("type", "preferences");
    // formData.append("status", selectedStatus);

    const formData = {
      id,
      title,
      description,
      status: selectedStatus,
    };

    try {
      const url = id
        ? `${LIVE_URL}/admin/brings/update`
        : `${LIVE_URL}/admin/brings/create`;

      const method = "POST";

      const response = await fetch(url, {
        method,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        const successMessage = id
          ? "preference updated successfully."
          : "preference saved successfully.";
        navigate(
          `/home/list-preference?message=${encodeURIComponent(successMessage)}`,
        );
      } else {
        setPopupMessage(
          `Failed to save preference. Status: ${response.status}`,
        );
      }
    } catch (error) {
      setPopupMessage("Error saving preference.");
    } finally {
      setLoading(false);
    }
  };

  const options = [
    { value: "true", label: "Publish" },
    { value: "false", label: "UnPublish" },
  ];

  if (loading) {
    return <Spinner />;
  }
  return (
    <>
      <div
        id="popup-message"
        className={`${styles.update_message} ${popupMessage.includes(
          "success",
        )}`}
      >
        {popupMessage && <p>{popupMessage}</p>}
      </div>
      <div className={`${styles.add_preference}`}>
        <header>
          <h2>{id ? "Update Preference" : "Add Preference"}</h2>
        </header>
        <section className={`${styles.section}`}>
          <label htmlFor="title">Preference Title</label>
          <br />
          <input
            type="text"
            id="title"
            value={title}
            onChange={handleTitleChange}
          />
          {errors.title && <p className={styles.error}>{errors.title}</p>}
          <br />
          <br />
          <label htmlFor="description"> Description</label>
          <br />
          <textarea
            type="text"
            id="title"
            value={description}
            onChange={handleDescriptionChange}
            maxLength={100}
            placeholder="Length should not exceed 100 characters."
          />
          {errors.description && (
            <p className={styles.error}>{errors.description}</p>
          )}
          <br />
          <br />
          <label htmlFor="status">Preference Status</label>
          <br />
          <div className={`${styles.select_container}`}>
            <select value={selectedStatus} onChange={handleSelectChange}>
              <option value="">Select Status</option>
              {options.map((option, index) => (
                <option key={index} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
            <FaChevronDown className={`${styles.chevron_down}`} />
          </div>
          {errors.selectedStatus && (
            <p className={styles.error}>{errors.selectedStatus}</p>
          )}
          <br />
          <div className={`${styles.button_container}`}>
            <button onClick={() => navigate("/home/list-preference")}>
              Cancel
            </button>
            <button onClick={handleSubmit}>
              {id ? "Update preference" : "Add preference"}
            </button>
          </div>
        </section>
      </div>
    </>
  );
};

export default AddPreference;
